import * as api from "@/request/api.js";
//获取区域信息
export async function getArea() {
	try {
		const res = await api.getArea({ data: "area_tree" });
		return res.data;
	} catch (error) {
		throw error;
	}
}

// 校验手机号
export function checkPhone(value) {
	return regex(/^1[2345789]\d{9}$/, parseInt(decodeURI(value)));
}

// 校验验证码
export function checkCode(value) {
	if (value && value.length == 4) {
		return true;
	} else {
		return false;
	}
}

// 校验密码
export function checkPassword(value) {
	return regex(/^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{6,20}$/, value);
}

/**
 * 正则
 * @param {Object} rule
 * @param {Object} value
 */
function regex(rule, value) {
	var pattern = new RegExp(rule);
	return pattern.test(value);
}

export async function getOrderActivity(){
	try {
		const res = await api.getOrderSearch();
		return res.data;
	} catch (error) {
		throw error;
	}
}